import { render } from "./02_Afordable.vue?vue&type=template&id=02f6109e&scoped=true"
import script from "./02_Afordable.vue?vue&type=script&lang=js"
export * from "./02_Afordable.vue?vue&type=script&lang=js"

import "./02_Afordable.vue?vue&type=style&index=0&id=02f6109e&lang=css"
import "./02_Afordable.vue?vue&type=style&index=1&id=02f6109e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f6109e"]])

export default __exports__